var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddStage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM13.75 8.25C13.75 7.55964 13.1904 7 12.5 7C11.8096 7 11.25 7.55964 11.25 8.25V10.75H8.75C8.05964 10.75 7.5 11.3096 7.5 12C7.5 12.6904 8.05964 13.25 8.75 13.25H11.25V15.75C11.25 16.4404 11.8096 17 12.5 17C13.1904 17 13.75 16.4404 13.75 15.75V13.25H16.25C16.9404 13.25 17.5 12.6904 17.5 12C17.5 11.3096 16.9404 10.75 16.25 10.75H13.75V8.25Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddStage);
export default __webpack_public_path__ + "static/media/add-stage.109f7b7110be21a98547cf1a3e1c89f8.svg";
export { ForwardRef as ReactComponent };